package com.xtream.composeapp.presentation.ui.tvchannels

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.BrokenImage
import androidx.compose.material.icons.rounded.DragHandle
import androidx.compose.material.icons.rounded.Tv
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import coil3.compose.rememberAsyncImagePainter
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.viewmodel.livetv.StreamControlViewModel
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStreamWithSortOrder
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.tv_channels
import com.xtream.ui.platform.isDpadNavigation
import com.xtream.ui.ui.widget.FocusPositioner
import com.xtream.ui.ui.widget.NavigationButton
import com.xtream.ui.ui.widget.TvButton
import kotlinx.coroutines.Dispatchers
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel


@Composable
fun TvChannelsManager(
    modifier: Modifier= Modifier,
    category: LiveCategory,
    onNavigationIconClick: (() -> Unit)?=null,

    ){
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner
    val streamControlViewModel: StreamControlViewModel = koinViewModel(
        viewModelStoreOwner = viewModelStoreOwner?: error("no viewModelStoreOwner provided")
    )

    TestTvChannels(
        streamControlViewModel=streamControlViewModel,
        category=category,
         modifier =modifier.fillMaxSize(),
             onNavigationIconClick= onNavigationIconClick

    )




}


@Composable
fun TestTvChannels(

    streamControlViewModel: StreamControlViewModel,
    category: LiveCategory,

    modifier: Modifier= Modifier,
    title: String=stringResource(Res.string.tv_channels),
    onNavigationIconClick: (() -> Unit)?=null,

    ){
    val scope= rememberCoroutineScope()
    LaunchedEffect(Unit){
        streamControlViewModel.emitGroup(category)
        val index=streamControlViewModel.indexOf(streamId = 8, categoryId = category.categoryId)
        println("in category ${category.categoryId}, INDEXOF: "+index)
        val stream= streamControlViewModel.findStreamByIndex(index, categoryId = category.categoryId)
        println("in category ${category.categoryId}, get stream by index ${stream}: "+streamControlViewModel.indexOf(streamId = 8, categoryId = category.categoryId))
    }


    val tvChannelsWithSortOrder  by streamControlViewModel.getTvChannelsWithSortOrder.collectAsStateWithLifecycle(emptyList())
    val tvChannelsListState = rememberLazyListState(0, 0)





    val isDpad = isDpadNavigation()
    fun swapPosition(from:Int, to:Int){
        streamControlViewModel.swap(from, to , if (isDpad) Dispatchers.Default else Dispatchers.Main)
      /*  with(streamControlViewModel){
            if (isDpad)
                     tvChannelsListState.requestScrollToItem(to)
                val dragged=tvChannelsWithSortOrder.getOrNull(from)
                val other=tvChannelsWithSortOrder.getOrNull(to)



            }
            else
            scope.launch(Dispatchers.Main) {
                val dragged=tvChannelsWithSortOrder.getOrNull(from)
                val other=tvChannelsWithSortOrder.getOrNull(to)

                swap(dragged, other )

            }

        }*/
    }
    val reorderState = rememberReorderableLazyColumnState(lazyListState = tvChannelsListState) { fromIndex, toIndex ->
        /*channels = channels.toMutableList().apply {
            add(toIndex, removeAt(fromIndex))
        }*/
        println("+++++: onmove")
        swapPosition(from = fromIndex, toIndex)
    }
    Scaffold(
        modifier = modifier,
        topBar = {
            @OptIn(ExperimentalMaterial3Api::class)
            TopAppBar(
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = MaterialTheme.colorScheme.background
                ),
                title = {
                    Text(
                        modifier = Modifier.fillMaxWidth(),
                        textAlign = TextAlign.Center,
                        text = title,
                        style = MaterialTheme.typography.titleLarge
                    )
                },
                actions = {
                    TvButton(
                        title = "Reset"
                    ) {
                        streamControlViewModel.resetToSortOrderFrom(category)
                    }
                },
                navigationIcon = {
                    onNavigationIconClick.takeIf { it!=null }?.let {
                        NavigationButton(
                            onClick = it,
                            colors =  IconButtonDefaults.iconButtonColors(
                                contentColor = MaterialTheme.colorScheme.onBackground
                            )

                        )
                    }

                }
            )
        }
    ) { innerPadding ->
        FocusPositioner(
            parentFraction = 0.5f,
            childFraction = 0.5f,
        ) {
            // ── NO key() wrapper here ─────────────────────────────────────────
            // key(selectedCategory?.categoryId) was remounting the entire
            // LazyColumn on every category switch, which dropped focus to
            // nowhere and let the Categories composable steal it back.
            // Items update in-place via stable keys in itemsIndexed instead.

            // Track which item is currently being dragged for the overlay clone
            var floatingDragItem by remember { mutableStateOf<LiveStreamWithSortOrder?>(null) }

            ReorderableLazyColumn(
                state = reorderState,
                modifier = Modifier.fillMaxSize().padding(innerPadding),
                autoScrollThresholdTop = 80.dp,
                autoScrollThresholdBottom = 80.dp,
                floatingDragContent = floatingDragItem?.let { item ->
                    // Render the same TvButton appearance as the real item
                    {
                        TvButton(
                            selected = false,
                            title = item.liveStream.name,
                            leadingIcon = rememberAsyncImagePainter(
                                model = item.liveStream.streamIcon,
                                placeholder = rememberVectorPainter(Icons.Rounded.Tv),
                                error = rememberVectorPainter(Icons.Rounded.BrokenImage)
                            ),
                            useIconTint = false,
                            fillParent = true,
                            contentPadding = PaddingValues(start = 4.dp),
                            trailingContent = {
                                Icon(Icons.Rounded.DragHandle, contentDescription = null)
                            },
                            onClick = {}
                        )
                    }
                }
            ) {
                itemsIndexed(
                    items = tvChannelsWithSortOrder,
                    key = { _, stream -> stream.liveStream.streamId }
                ) { index, item ->
                    ReorderableItem(
                        state = reorderState,
                        key = item.liveStream.streamId,
                        index = index
                    ) { isDragging ->
                        // Sync floating item when drag starts on this item
                        LaunchedEffect(isDragging) {
                            if (isDragging) floatingDragItem = item
                            else if (floatingDragItem?.liveStream?.streamId == item.liveStream.streamId) {
                                floatingDragItem = null
                            }
                        }

                        TvButton(
                            selected = false,
                            title = "${index + 1} | ${item.liveStream.name}",
                            modifier = Modifier
                                .fillMaxWidth()
                                //.focusProperties { canFocus = false }
                            ,
                            leadingIcon = rememberAsyncImagePainter(
                                model = item.liveStream.streamIcon,
                                placeholder = rememberVectorPainter(Icons.Rounded.Tv),
                                error = rememberVectorPainter(Icons.Rounded.BrokenImage)
                            ),
                            useIconTint = false,
                            fillParent = true,
                            contentPadding = PaddingValues(start = 4.dp),
                            trailingContent = {
                                Icon(Icons.Rounded.DragHandle, contentDescription = "Reorder")
                            },
                            onClick = {}
                        )
                    }
                }
            }
        }
    }

}










